"use client";
import { jsxs as c, jsx as o } from "react/jsx-runtime";
import { memo as l, forwardRef as s } from "react";
import { useSvgIcon as e } from "../useSvgIcon.js";
const d = l(
  s((r, i) => {
    const { monochrome: C, ...n } = r, t = e({
      ...n,
      ref: i
    });
    return /* @__PURE__ */ c(
      "svg",
      {
        width: 24,
        height: 24,
        viewBox: "0 0 64 64",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...t(),
        children: [
          /* @__PURE__ */ o(
            "path",
            {
              d: "M14.0133 22.668C13.0809 22.668 12.2899 22.9829 11.6396 23.6127C10.9893 24.2425 10.6641 24.9982 10.6641 25.8803V39.4236C10.6641 40.3277 10.9892 41.0933 11.6396 41.7232C12.2899 42.353 13.0809 42.668 14.0133 42.668C14.945 42.668 15.7313 42.3531 16.3715 41.7232C17.0104 41.0934 17.3307 40.3277 17.3307 39.4236V25.8803C17.3307 24.9981 17.0056 24.2425 16.3552 23.6127C15.7048 22.9829 14.924 22.668 14.0133 22.668Z",
              fill: C ? "var(--icon-color)" : "#A4C639"
            }
          ),
          /* @__PURE__ */ o(
            "path",
            {
              d: "M38.5558 11.3571L40.6027 7.34254C40.7371 7.07676 40.6893 6.87295 40.4589 6.72964C40.2088 6.60607 40.0167 6.66869 39.8824 6.91307L37.8068 10.9597C35.9805 10.1012 34.0488 9.67121 32.0119 9.67121C29.9745 9.67121 28.0427 10.1013 26.217 10.9597L24.1414 6.91307C24.0065 6.66869 23.8144 6.60662 23.5649 6.72964C23.334 6.8736 23.2862 7.07676 23.4211 7.34254L25.4681 11.3571C23.3924 12.4825 21.7393 14.0498 20.5093 16.0624C19.2793 18.0761 18.6641 20.2767 18.6641 22.668H45.3307C45.3307 20.2772 44.7154 18.0766 43.4855 16.0624C42.2554 14.0498 40.6118 12.4825 38.5558 11.3571ZM26.7213 17.1963C26.5 17.4322 26.2356 17.5496 25.9282 17.5496C25.6203 17.5496 25.3613 17.4322 25.15 17.1963C24.9387 16.9615 24.833 16.6816 24.833 16.3537C24.833 16.027 24.9387 15.7464 25.15 15.5111C25.3613 15.2763 25.6209 15.1589 25.9282 15.1589C26.2356 15.1589 26.5 15.2763 26.7213 15.5111C26.9422 15.747 27.0531 16.027 27.0531 16.3537C27.0525 16.681 26.9417 16.9615 26.7213 17.1963ZM38.8726 17.1963C38.6609 17.4322 38.4013 17.5496 38.0945 17.5496C37.7865 17.5496 37.5222 17.4322 37.3012 17.1963C37.0799 16.9615 36.9695 16.6816 36.9695 16.3537C36.9695 16.027 37.0799 15.7464 37.3012 15.5111C37.5222 15.2763 37.7865 15.1589 38.0945 15.1589C38.4018 15.1589 38.6608 15.2763 38.8726 15.5111C39.0841 15.747 39.1896 16.027 39.1896 16.3537C39.1896 16.681 39.084 16.9615 38.8726 17.1963Z",
              fill: C ? "var(--icon-color)" : "#A4C639"
            }
          ),
          /* @__PURE__ */ o(
            "path",
            {
              d: "M18.6641 44.6667C18.6641 45.5918 18.9737 46.3749 19.5932 47.0175C20.2132 47.6601 20.968 47.9814 21.8591 47.9814L23.9974 47.9821L24.0164 54.02C24.0222 55.8518 25.509 57.3337 27.3409 57.3333V57.3333C29.1763 57.333 30.6641 55.845 30.6641 54.0095V47.9814L33.3307 47.9821V53.9997C33.3307 55.8408 34.8233 57.3332 36.6644 57.333V57.333C38.5052 57.3328 39.9974 55.8405 39.9974 53.9997V47.9814L42.1645 47.9821C43.0358 47.9821 43.7809 47.6607 44.4015 47.0181C45.0209 46.3754 45.3307 45.5923 45.3307 44.6673V24H18.6641V44.6667Z",
              fill: C ? "var(--icon-color)" : "#A4C639"
            }
          ),
          /* @__PURE__ */ o(
            "path",
            {
              d: "M49.9812 22.668C49.0703 22.668 48.29 22.9782 47.6396 23.597C46.9892 24.217 46.6641 24.9785 46.6641 25.8803V39.4236C46.6641 40.3277 46.9891 41.0933 47.6396 41.7232C48.29 42.3531 49.0709 42.668 49.9812 42.668C50.9131 42.668 51.7048 42.3531 52.3552 41.7232C53.0057 41.0933 53.3307 40.3277 53.3307 39.4236V25.8803C53.3307 24.9784 53.0057 24.217 52.3552 23.597C51.7048 22.9782 50.9131 22.668 49.9812 22.668Z",
              fill: C ? "var(--icon-color)" : "#A4C639"
            }
          )
        ]
      }
    );
  })
);
d.displayName = "IconAndroid";
export {
  d as IconAndroid
};
